import React from 'react';
import { useGrants } from '../../Data/Business';
import Loading from '../Loading';
import API from '../../Services/API';

export default ({userId, empty, you = 'You', initials = false}) => {
    const {keyedByUserId, isLoading} = useGrants();

    if (userId === null) {
        return empty ?? <span className="text-muted">-</span>;
    }

    if (you && userId === API.jwt('sub')) {
        return you;
    }

    if (isLoading) {
        return <Loading inline />;
    }

    const user = keyedByUserId[userId];

    if (!user) {
        return initials ? '??' : 'Unknown user';
    }

    if (initials) {
        return user.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
    }

    return user;
}
